var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.5,483.5c0,15.9,10,30.1,25,35.4c43.6,15.4,75,57.1,75,106.1c0,48.9-31.4,90.6-75,106.1 c-15,5.3-25,19.4-25,35.4V850c0,48.4,39.2,87.5,87.5,87.5h900c48.3,0,87.5-39.1,87.5-87.5v-83.6c0-15.9-10-30.1-25-35.4 c-43.6-15.4-75-57.1-75-106.1c0-48.9,31.4-90.6,75-106.1c15-5.3,25-19.4,25-35.4V350c0-48.4-39.2-87.5-87.5-87.5H150 c-48.3,0-87.5,39.1-87.5,87.5V483.5z M788.4,660.8c-29.3-29.2-76.8-29.2-106.1,0c-29.2,29.3-29.2,76.8,0,106 c29.3,29.3,76.8,29.3,106.1,0C817.7,737.6,817.7,690.1,788.4,660.8z M723.5,423.5l-300,300c-14.6,14.6-14.6,38.4,0,53 c14.6,14.6,38.4,14.6,53,0l300-300c14.6-14.6,14.6-38.4,0-53C761.9,408.9,738.1,408.9,723.5,423.5z M517.7,440.9 c-29.3-29.3-76.8-29.3-106.1,0c-29.2,29.2-29.2,76.8,0,106c29.3,29.2,76.8,29.2,106.1,0C547,517.7,547,470.1,517.7,440.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucher);
export default __webpack_public_path__ + "static/media/Voucher.6ec5fc7c3a6efdf67cf98a91563628e0.svg";
export { ForwardRef as ReactComponent };